import React, {Component} from 'react';
import Api from "../../utils/Api";
import LoadingSplash from "../../globalComponents/LoadingSplash";
import TimeRange from "../../utils/TimeRange";
import StaticFunctions from "../../utils/StaticFunctions";
import CSVDownloadButton from "../../utils/CSVDownloadButton";
import TimerangeSelector from "../../globalComponents/TimerangeSelector";
import LocationSelector from "../../globalComponents/LocationSelector";
import MachineSelector from "../../globalComponents/MachineSelector";
import DesignSelector from "../../globalComponents/DesignSelector";
import ShiftSelector from "../../globalComponents/ShiftSelector";
import TableContainer from "../../utils/TableContainer";
import MachineStates from "../../utils/MachineStates";
import moment from "moment/moment";

class ReportDesignSummary extends Component {
/*
    static propTypes = {
        baseData: PropTypes.object.isRequired,
        machines: PropTypes.instanceOf(Machines).isRequired,
    };
*/
    constructor(props) {

        super(props);

        this.api = new Api();

        this.translate = this.props.baseData.translate;
        this.userLanguage = this.props.baseData.userData.language;
        this.timeFormats = this.props.baseData.languages.getFormatByLanguage(this.userLanguage);
        this.saveSettings = this.props.baseData.saveSettings;

        this.state = {
            reportStatus: null,
            reportParams: null,
            timeRange: null, // TimeRange
            selectedLocationId: 0,
            selectedLocationName: 'all',
            selectedMachine: {value: 'all', label: this.translate('all')},
            selectedDesign: null,
            selectedShift: null,
            designs: [],
            currentCompanyId: props.baseData.companies.currentCompany ? props.baseData.companies.currentCompany.id : null,
            requestedParams: null, // stringified parameters to prevent double-request
            tableData: null,
            errorData: null
        };

        this.reportKey = 'designSummary';

        this.updateDesigns = this.updateDesigns.bind(this);
        this.requestReport = this.requestReport.bind(this);
        this.timerangeChanged = this.timerangeChanged.bind(this);
        this.locationSelected = this.locationSelected.bind(this);
        this.machineSelected = this.machineSelected.bind(this);
        this.designSelected = this.designSelected.bind(this);
        this.shiftSelected = this.shiftSelected.bind(this);

    }

    componentWillMount() {

        this.updateDesigns();

        const newState = {};

        // Timerange aus den userprops laden
        const tr = new TimeRange();
        const momentYesterday = moment().add(-1, 'days');

        tr.setRange(momentYesterday.clone().startOf('day'), momentYesterday.clone().endOf('day'));

        if (tr && tr.isValid()) newState.timeRange = tr;

        // Standort aus den userprops laden
        const locationId = this.getReportSetting('locationId');

        if (locationId) newState.selectedLocationId = locationId;

        // Machines aus den userprops laden
        const machine = this.getReportSetting('machine');

        if (machine) newState.selectedMachine = JSON.parse(machine);

        // Design aus den userprops laden
        const design = this.getReportSetting('design');

        if (design) newState.selectedDesign = design;

        // Shift aus den userprops laden
        const sid = this.getReportSetting('shiftId');

        if (sid) {
            let shift = this.props.baseData.shifts.getShiftById(sid);

            if (shift) newState.selectedShift = shift;
        }

        if (newState) {
            this.setState(newState);
        }

    }

    componentWillReceiveProps(nextProps) {

        if (nextProps.baseData.companies && nextProps.baseData.companies.currentCompany) {
            if (nextProps.baseData.companies.currentCompany.id !== this.state.currentCompanyId) {
                this.setState({
                    selectedLocationId: 0,
                    selectedMachine: {value: 'all', label: this.translate('all')},
                    selectedShift: null,
                    tableData: null,
                    currentCompanyId: nextProps.baseData.companies.currentCompany.id
                });
            }
        }

    }

    getReportSetting(key, defaultValue = null) {

        const settings = this.props.baseData.userData.settings ? this.props.baseData.userData.settings : {};
        const reportSettings = (settings.hasOwnProperty('reports') && settings.reports.hasOwnProperty(this.reportKey)) ? settings.reports[this.reportKey] : {};

        return (reportSettings.hasOwnProperty(key)) ? reportSettings[key] : defaultValue;

    }

    updateDesigns() {

        const params = {
            "id_company": this.props.baseData.companies.currentCompany.id,
            'maxRows': this.state.maxEntries,
            'offset': this.state.maxEntries * this.state.currentPage
        };

        const strParams = JSON.stringify(params);

        if (this.sentParams === strParams) return;

        const callback = function(res) {
            if (res) {
                this.setState({
                    designs: res
                });
            }
        }.bind(this);

        this.api.request('GetDesigns', params, callback, null);
        this.sentParams = strParams;

    }

    getRequestParams() {

        const tr = this.state.timeRange;
        const dateFrom = tr ? tr.getFromMoment() : null;
        const dateTill = tr ? tr.getTillMoment() : null;
        const locationId = this.state.selectedLocationId;
        const design = this.state.selectedDesign;
        const machineId = this.state.selectedMachine ? this.state.selectedMachine.value : null;
        const machineIds = (machineId === 'all') ? this.props.machines.getAllMachineIdsFromLocation(locationId) : [machineId];

        // Check, if all data is set
        if (!dateFrom || !dateTill || !design || locationId === null || !machineId) return;
        if (!dateFrom.isValid() || !dateTill.isValid()) return;

        return {
            companyId: this.props.baseData.companies.currentCompany.id,
            locationId: locationId,
            machineIds: machineIds,
            design: design,
            from: dateFrom.unix(),
            till: dateTill.unix(),
            shift: this.state.selectedShift ? this.state.selectedShift.getRange() : null,
            timezone: this.props.baseData.companies.currentCompany.timezone,
        };

    }

    requestReport() {

        if (this.state.reportStatus === 'requested') return null;

        const params = this.getRequestParams();

        if (params === null) return null;

        const sParams = JSON.stringify(params);

        if (sParams === this.state.requestedParams) return null;

        const {reportParams, ...newReportParams} = {...this.state};

        const callback = function(res) {
            if (res) {
                this.setState({
                    reportStatus: 'ready',
                    tableData: res,
                    errorData: null,
                });
            }
        }.bind(this);

        const error = function(error) {
            if (error) {
                this.setState({
                    reportStatus: 'error',
                    tableData: null,
                    errorData: error,
                });
            }
        }.bind(this);

        this.setState({
            reportStatus: 'requested',
            reportParams: newReportParams,
            requestedParams: sParams,
            tableData: null,
            errorData: null,
        }, () => {
            this.api.request('ReportDesignSummary', params, callback, error);
        });

    }

    timerangeChanged(newRange) {

        if (newRange && (newRange instanceof TimeRange) && newRange.isValid()) {
            this.setState({
                timeRange: newRange,
            });

            // Safe Timerange to Userconfig
            if (this.saveSettings) {
                this.saveSettings('reports', {report: this.reportKey, key: 'timeRange', value: newRange.serialize()});
            }
        }

    }

    locationSelected(location) {

        const allMachines = {value: 'all', label: this.translate('all')};

        this.setState({
            selectedLocationId: location ? parseInt(location.id) : 0,
            selectedLocationName: location ? location.name : '',
            selectedMachine: allMachines
        });

        if (this.saveSettings && location) {
            this.saveSettings('reports', {report: this.reportKey, key: 'locationId', value: location.id});
            this.machineSelected(allMachines);
        }

    }

    machineSelected(machine) {

        this.setState({
            selectedMachine: machine
        });

        // Safe Machine to Userconfig
        if (this.saveSettings) {
            this.saveSettings('reports', {report: this.reportKey, key: 'machine', value: ((machine) ? JSON.stringify(machine) : null)});
        }

    }

    designSelected(design) {

        this.setState({
			selectedDesign: {id: design.designId, stitches: design.stitches}
        });

        // Safe Design to Userconfig
        if (this.saveSettings && design) {
            this.saveSettings('reports', {report: this.reportKey, key: 'design', value: JSON.stringify({id: design.designId, stitches: design.stitches})});
        }

    }

    shiftSelected(shift) {

        this.setState({
            selectedShift: shift
        });

        // Safe Shift-id to Userconfig
        if (this.saveSettings && shift) {
            this.saveSettings('reports', {report: this.reportKey, key: 'shiftId', value: shift.id});
        }

    }

    getErrorBlock() {

        let errorBlock = null;

        if (this.state.errorData || this.state.reportStatus === 'error') {
            errorBlock = <span className="warningBox ma-bo-10">{this.translate('errorOccured')}</span>;
        } else if (!this.state.reportParams.timeRange || !this.state.reportParams.timeRange.isValid()) {
            errorBlock = <span className="warningBox ma-bo-10">{this.translate('timerangeIsUnset')}</span>;
        } else if (!this.state.reportParams.timeRange || !this.state.reportParams.timeRange.isNotInFuture()) {
            errorBlock = <span className="warningBox ma-bo-10">{this.translate('timerangeIsInFuture')}</span>;
        } else if (!this.state.reportParams && this.state.reportParams.selectedLocationId === null) {
            errorBlock = <span className="warningBox ma-bo-10">{this.translate('locationIsUnset')}</span>;
        } else if (!this.state.reportParams && this.state.reportParams.selectedMachine === null) {
            errorBlock = <span className="warningBox ma-bo-10">{this.translate('machineIsUnset')}</span>;
        } else if (!this.state.reportParams && this.state.reportParams.selectedDesign === null) {
            errorBlock = <span className="warningBox ma-bo-10">{this.translate('designIsUnset')}</span>;
        } else if (this.state.tableData === null) {
            errorBlock = <LoadingSplash color={'dark'}/>;
        } else if (this.state.tableData && this.state.tableData.length === 0) {
            errorBlock = <span className="warningBox ma-bo-10">{this.translate('noDataFound')}</span>;
        }

        return (errorBlock !== null) ? errorBlock : null;

    }

    getChartHeadline(timeRange, otherParams = {}) {

        const params = {
            location: {id: this.state.reportParams.selectedLocationId, name: this.state.reportParams.selectedLocationName},
            locationTitle: this.translate('location'),
            allLocationsTitle: this.translate('allLocations'),
            machine: this.state.reportParams.selectedMachine,
            machineTitle: this.translate('machine'),
            allMachinesTitle: this.translate('allMachines'),
            design: this.state.reportParams.selectedDesign,
            designTitle: this.translate('design'),
			stitchesUnit: this.translate('stitches'),
            allDesignsTitle: this.translate('allDesigns'),
            timerange: timeRange,
            formatedDate: this.timeFormats.fullDate,
            timerangeTitle: this.translate('timerange'),
            shift: this.state.reportParams.selectedShift,
            shiftTitle: this.translate('shift'),
            groupingOpt: this.groupingOpt,
            groupingId: this.state.reportParams.selectedGrouping,
            groupingTitle: this.translate('grouping')
        };

        return StaticFunctions.createReportHeadlineFromParams({...params, ...otherParams});

    }

    getTableHeader() {

        const headline = this.getChartHeadline(this.state.timeRange);

        return (
            <nav>
                <h1>{headline}</h1>
            </nav>
        );

    }

    getCsvContent() {

        const csvContent = {
            csvTitle: [],
            csvColumns: [],
            csvData: [],
        };

        if (this.state.reportStatus === 'ready') {
            csvContent.csvTitle.push(this.getChartHeadline(this.state.reportParams.timeRange));
            csvContent.csvColumns.push(this.getCsvTableColumns());
            csvContent.csvData.push(this.getCsvTableRows());
        }

        return csvContent;

    }

    getCsvTableColumns() {

        return [
            {
                key:  'column1',
                name: ' ',
            },
            {
                key:  'column2',
                name: ' ',
            },
            {
                key: 'column3',
                name: ' ',
            },
            {
                key:  'column4',
                name: ' ',
            },
            {
                key:  'column5',
                name: ' ',
            },
            {
                key:  'column6',
                name: ' ',
            },
        ];

    }

    getCsvTableRows() {

        const reportData = this.calculateReportData();
        const tableColumns = this.getTableColumns();
        const tableRows = this.getTableRows();
        const csvData = [];

        if (reportData) {
            csvData.push({
                column1: this.translate('passings'),
                column2: StaticFunctions.formatedNumber(reportData.passings),
                column3: ' ',
                column4: this.translate('stitchTime'),
                column5: StaticFunctions.convertSecondsToFormatedString(reportData.stitchTime),
                column6: ' ',
            });

            csvData.push({
                column1: this.translate('numberOfPieces'),
                column2: StaticFunctions.formatedNumber(reportData.pieces),
                column3: ' ',
                column4: this.translate('threadbreakTime'),
                column5: StaticFunctions.convertSecondsToFormatedString(reportData.threadbreakTime),
                column6: ' ',
            });

            csvData.push({
                column1: this.translate('utilization'),
                column2: reportData.utilization.toFixed(2).replace('.', ',') + ' %',
                column3: ' ',
                column4: this.translate('setupTime'),
                column5: StaticFunctions.convertSecondsToFormatedString(reportData.setupTime),
                column6: ' ',
            });

            csvData.push({
                column1: ' ',
                column2: ' ',
                column3: ' ',
                column4: this.translate('productionTime'),
                column5: StaticFunctions.convertSecondsToFormatedString(reportData.productionTime),
                column6: ' ',
            });

            csvData.push({
                column1: ' ',
                column2: ' ',
                column3: ' ',
                column4: this.translate('operatorBreaks'),
                column5: StaticFunctions.convertSecondsToFormatedString(reportData.operatorBreaks),
                column6: ' ',
            });

            csvData.push({
                column1: ' ',
                column2: ' ',
                column3: ' ',
                column4: this.translate('downTime'),
                column5: StaticFunctions.convertSecondsToFormatedString(reportData.downTime),
                column6: ' ',
            });

            csvData.push({
                column1: ' ',
                column2: ' ',
                column3: ' ',
                column4: this.translate('totalTime'),
                column5: StaticFunctions.convertSecondsToFormatedString(reportData.totalTime),
                column6: ' ',
            });
        }

        if (tableColumns && tableRows) {
            csvData.push({column1: ' ', column2: ' ', column3: ' ', column4: ' ', column5: ' ', column6: ' '});
            csvData.push({column1: ' ', column2: ' ', column3: ' ', column4: ' ', column5: ' ', column6: ' '});

            csvData.push({
                column1: this.translate('designId'),
                column2: this.translate('passings'),
                column3: this.translate('numberOfPieces'),
                column4: this.translate('stitchTime'),
                column5: this.translate('threadbreakTime'),
                column6: ' ',
            });

            tableRows.forEach(
                (row) => {
                    csvData.push({
                        column1: row.designId,
                        column2: row.passings,
                        column3: row.numberOfPieces,
                        column4: row.stitchTime,
                        column5: row.threadbreakTime,
                        column6: ' ',
                    });
                }
            );
        }

        return csvData;

    }

    getTableColumns() {

        return [
            {
                key: 'designId',
                nameKey: 'designId',
                sortType: 'string',
            },
			{
				key: 'designStitches',
				nameKey: 'designStitches',
				classes: 'text-right',
				sortType: 'int',
			},
            /*{
                key: 'machineId',
                nameKey: 'machineId',
                sortType: 'string',
            },
            {
                key: 'machineName',
                nameKey: 'machineName',
                sortType: 'string',
            },*/
            {
                key: 'passings',
                nameKey: 'passings',
                classes: 'text-right',
                sortType: 'int',
            },
            {
                key: 'numberOfPieces',
                nameKey: 'numberOfPieces',
                classes: 'text-right',
                sortType: 'int',
            },
            /*{
                key: 'stitches',
                nameKey: 'stitches',
                classes: 'text-right',
                sortType: 'int',
            },
            {
                key: 'threadbreaks',
                nameKey: 'threadbreaks',
                classes: 'text-right',
                sortType: 'int',
            },
            {
                key: 'threadBreaksPer10KStiches',
                nameKey: 'threadBreaksPer10KStiches',
                classes: 'text-right',
                sortType: 'sting',
            },*/
            {
                key: 'stitchTime',
                nameKey: 'stitchTime',
                classes: 'text-right',
                sortType: 'string',
            },
            {
                key: 'threadbreakTime',
                nameKey: 'threadbreakTime',
                classes: 'text-right',
                sortType: 'string',
            },
        ];

    }

    getTableRows() {

        const data = this.state.tableData;
        const stitchStatusList = MachineStates.getStitchStatusList();
        const groupedRows = {};
        const rows = [];

        if (data) {
            data.forEach(
                (row) => {
					const key = row.designId + '_' + row.stitches;
                    const machine = this.props.machines.getMachineByMachineId(row.machineId);

					if (!groupedRows.hasOwnProperty(key)) {
						groupedRows[key] = {
							designId: row.designId,
							designStitches: StaticFunctions.formatedNumber(row.stitches),
							machineId: row.machineId,
							machineName: row.machineName,
							stitches: parseInt(row.stitches),
							threadbreaks: parseInt(row.threadbreaks),
							passings: 0,
							numberOfPieces: 0,
							stitchTime: 0,
							threadbreakTime: 0
						};
					}

					groupedRows[key].stitches += parseInt(row.stitches);
					groupedRows[key].threadbreaks += parseInt(row.threadbreaks);

					if (row.status === '1012') groupedRows[key].passings += parseInt(row.counter);
					if (row.status === '1012') groupedRows[key].numberOfPieces += parseInt(row.counter) * machine.getHeads();
					if (stitchStatusList.indexOf(parseInt(row.status)) >= 0) groupedRows[key].stitchTime += Math.floor(parseInt(row.pastTime) / 1000);
					if (row.status === '1066') groupedRows[key].threadbreakTime += Math.floor(parseInt(row.pastTime) / 1000);
                }
            );
        }

        if (groupedRows) {
            for (let key in groupedRows) {
                let rowTemp = groupedRows[key];

                rows.push({
                    id: key,
                    designId: rowTemp.designId,
					designStitches: rowTemp.designStitches,
                    machineId: rowTemp.machineId,
                    machineName: rowTemp.machineName,
                    stitches: StaticFunctions.formatedNumber(rowTemp.stitches),
                    threadbreaks: StaticFunctions.formatedNumber(rowTemp.threadbreaks),
                    passings: StaticFunctions.formatedNumber(rowTemp.passings),
                    numberOfPieces: StaticFunctions.formatedNumber(rowTemp.numberOfPieces),
                    threadBreaksPer10KStiches: StaticFunctions.calcThreadbreaksByRatio(rowTemp.stitches, rowTemp.threadbreaks).replace('.', ','),
                    stitchTime: StaticFunctions.convertSecondsToFormatedString(rowTemp.stitchTime),
                    threadbreakTime: StaticFunctions.convertSecondsToFormatedString(rowTemp.threadbreakTime),
                });
            }
        }

        return rows;

    }

    calculateReportData() {

        if (!this.state.tableData || this.state.reportParams.selectedLocationId === null || !this.state.reportParams.selectedMachine) return null;

        const reportData = this.state.tableData;
        const calculatedData = {
            stitches: 0,
            threadbreaks: 0,
            passings: 0,
            pieces: 0,
            stitchesPerMin: 0,
            entirePastTime: 0,
            utilization: 0,
            stitchTime: 0,
            threadbreakTime: 0,
            setupTime: 0,
            productionTime: 0,
            operatorBreaks: 0,
            downTime: 0,
            totalTime: 0,
        };

        calculatedData.stitchTime += MachineStates.calculateStitchTime(reportData, 's');
        calculatedData.threadbreakTime += MachineStates.calculateThreadbreakTime(reportData, 's');
        calculatedData.setupTime += MachineStates.calculateSetupTime(reportData, 's');
        calculatedData.productionTime += MachineStates.calculateProductionTime(reportData, 's');
        calculatedData.operatorBreaks += MachineStates.calculateBreakTime(reportData, 's');
        calculatedData.downTime += MachineStates.calculateDownTime(reportData, 's');
        calculatedData.totalTime += MachineStates.calculateTotalTime(reportData, 's');

        if (reportData) {
            reportData.forEach(
                (data) => {
                    let heads = this.props.machines.getMachineHeadsByMachineId(data.machineId);

                    if (data.stitches) calculatedData.stitches += parseInt(data.stitches);
                    if (data.threadbreaks) calculatedData.threadbreaks += parseInt(data.threadbreaks);
                    if (data.pastTime) calculatedData.entirePastTime += parseInt(data.pastTime);

                    if (data.status === '1012') {
                        calculatedData.passings += parseInt(data.counter);
                        calculatedData.pieces += parseInt(data.counter) * heads;
                    }
                }
            );
        }

        if (calculatedData.totalTime > 0 && calculatedData.productionTime > 0) calculatedData.utilization = (100 / calculatedData.totalTime) * calculatedData.productionTime;
        if (calculatedData.stitches > 0 && calculatedData.totalTime > 0) calculatedData.stitchesPerMin = (calculatedData.stitches / (calculatedData.totalTime / 60));

        return calculatedData;

    }

    renderStatusBlock(statusData) {

        if (!statusData) return null;

        let statusBlock = [];

        for (let statusCode in statusData) {
            let status = statusData[statusCode];
            let formatedPastTime = StaticFunctions.convertSecondsToFormatedString(status.pastTime / 1000);

            statusBlock.push(
                <tr key={statusCode}>
                    <td className="text-left labelSpan">{this.translate(statusCode)}</td>

                    <td className="text-left">
                        <input
                            name={statusCode}
                            type="text"
                            value={formatedPastTime}
                            disabled={true}
                        />
                    </td>
                </tr>
            );
        }

        return (
            <div className="formRow clearfix">
                <div className="col-sm-4">
                    <div className="ma-bo-10">
                        <table>
                            <tbody>
                                {statusBlock}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );

    }

    renderRequestButton() {

        const reportParams = this.getRequestParams();
        const sParams = JSON.stringify(reportParams);

        if (this.state.reportStatus === 'requested' || sParams === this.state.requestedParams) {
            return (
                <a className="prewLink disabled-link">{this.translate('requestReport')}</a>
            );
        } else {
            return (
                <a className="prewLink orangeButton" onClick={() => this.requestReport()}>{this.translate('requestReport')}</a>
            );
        }

    }

    renderDownloadButtons() {

        if (this.state.reportStatus !== 'ready' || !this.state.reportParams || this.getErrorBlock() !== null) {
            return (
                <div className="bottomLinks clearfix">
                    <div><button className="disabled-link">{this.translate('csvDownloadLabel') + ' (CSV)'}</button></div>
                </div>
            );
        } else {
            const csvContent = this.getCsvContent();

            return (
                <div className="bottomLinks clearfix">
                    <CSVDownloadButton
                        baseData={this.props.baseData}
                        fileName={this.props.reportName}
                        csvTitle={csvContent.csvTitle}
                        columns={csvContent.csvColumns}
                        data={csvContent.csvData}
                    />
                </div>
            );
        }

    }

    renderReportArea() {

        if (this.state.reportStatus === null) return null;
        if (this.state.reportStatus === 'requested') return <LoadingSplash color={'dark'}/>;

        const errorBlock = this.getErrorBlock();

        if (errorBlock !== null) return errorBlock;

        const headline = this.getChartHeadline(this.state.reportParams.timeRange);
        const reportData = this.calculateReportData();
        const tableColumns = this.getTableColumns();
        const tableRows = this.getTableRows();

        return (
            <div>
                <nav>
                    <h1>{headline}</h1>
                </nav>

                <div className="formSettings">
                    <div className="formRow clearfix">
                        <div className="col-sm-4">
                            <div className="ma-bo-10">
                                <table>
                                    <tbody>
                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('passings')}</td>

                                        <td className="text-left">
                                            <input
                                                name="passings"
                                                type="text"
                                                value={StaticFunctions.formatedNumber(reportData.passings)}
                                                disabled={true}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('numberOfPieces')}</td>

                                        <td className="text-left">
                                            <input
                                                name="numberOfPieces"
                                                type="text"
                                                value={StaticFunctions.formatedNumber(reportData.pieces)}
                                                disabled={true}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('utilization')}</td>

                                        <td className="text-left">
                                            <input
                                                name="utilization"
                                                type="text"
                                                value={StaticFunctions.formatedNumber(reportData.utilization, 2) + ' %'}
                                                disabled={true}
                                            />
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className="col-sm-4">
                            <div className="ma-bo-10">
                                <table>
                                    <tbody>
                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('stitchTime')}</td>

                                        <td className="text-left">
                                            <input
                                                name="stitchTime"
                                                type="text"
                                                value={StaticFunctions.convertSecondsToFormatedString(reportData.stitchTime)}
                                                disabled={true}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('threadbreakTime')}</td>

                                        <td className="text-left">
                                            <input
                                                name="threadbreakTime"
                                                type="text"
                                                value={StaticFunctions.convertSecondsToFormatedString(reportData.threadbreakTime)}
                                                disabled={true}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('setupTime')}</td>

                                        <td className="text-left">
                                            <input
                                                name="setupTime"
                                                type="text"
                                                value={StaticFunctions.convertSecondsToFormatedString(reportData.setupTime)}
                                                disabled={true}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('productionTime')}</td>

                                        <td className="text-left">
                                            <input
                                                name="productionTime"
                                                type="text"
                                                value={StaticFunctions.convertSecondsToFormatedString(reportData.productionTime)}
                                                disabled={true}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('operatorBreaks')}</td>

                                        <td className="text-left">
                                            <input
                                                name="operatorBreaks"
                                                type="text"
                                                value={StaticFunctions.convertSecondsToFormatedString(reportData.operatorBreaks)}
                                                disabled={true}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('downTime')}</td>

                                        <td className="text-left">
                                            <input
                                                name="downTime"
                                                type="text"
                                                value={StaticFunctions.convertSecondsToFormatedString(reportData.downTime)}
                                                disabled={true}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('totalTime')}</td>

                                        <td className="text-left">
                                            <input
                                                name="totalTime"
                                                type="text"
                                                value={StaticFunctions.convertSecondsToFormatedString(reportData.totalTime)}
                                                disabled={true}
                                            />
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="ma-bo-10">
                    <TableContainer
                        baseData={this.props.baseData}
                        columns={tableColumns}
                        rows={tableRows}
                    />
                </div>
            </div>
        );

    }

    render() {

        const timerangeFormat = this.timeFormats.fullDate;
        const machineOptions = this.props.machines;
        const designOptions = this.state.designs;

        const reportArea = this.renderReportArea();
        const requestButton = this.renderRequestButton();
        const downloadArea = this.renderDownloadButtons();

        const csvContent = this.getCsvContent();

        return (
            <div>
                <div id="reportSettings" className="clearfix">
                    <div className="clearfix">
                        <div className="col-sm-4">
                            <div className="ma-bo-10">
                                <h4>{this.translate('timerange')}</h4>

                                <div>
                                    <TimerangeSelector
                                        TimeRange={this.state.timeRange}
                                        displayFormat={timerangeFormat}
                                        translate={this.translate}
                                        onTimeRangeChanged={this.timerangeChanged}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-2">
                            <div className="ma-bo-10">
                                <h4>{this.translate('location')}</h4>

                                <div>
                                    <LocationSelector
                                        baseData={this.props.baseData}
                                        currentLocation={this.state.selectedLocationId}
                                        placeholder={this.translate('select') + '...'}
                                        onLocationSelected={(location) => this.locationSelected(location)}
                                    />
                                </div>
                            </div>

                            <div className="ma-bo-10">
                                <h4>{this.translate('machine')}</h4>

                                <div>
                                    <MachineSelector
                                        machine={machineOptions}
                                        currentMachine={this.state.selectedMachine}
                                        currentLocation={this.state.selectedLocationId}
                                        translate={this.translate}
                                        addAllOption={true}
                                        onMachineSelected={(machine) => this.machineSelected(machine)}
                                    />
                                </div>
                            </div>

                            <div className="ma-bo-10">
                                <h4>{this.translate('design')}</h4>

                                <div>
                                    <DesignSelector
                                        name="design-select"
                                        baseData={this.props.baseData}
                                        currentDesign={this.state.selectedDesign}
                                        designs={designOptions}
                                        translate={this.translate}
                                        onDesignSelected={(design) => this.designSelected(design)}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-2">
                            <div className="ma-bo-10">
                                <h4>{this.translate('shift')}</h4>

                                <div>
                                    <ShiftSelector
                                        baseData={this.props.baseData}
                                        currentShift={this.state.selectedShift}
                                        onShiftSelected={(shift) => this.shiftSelected(shift)}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-2">
                            <div className="ma-bo-10">
                                <h4>{this.translate('downloadReport')}</h4>

                                {downloadArea}
                            </div>
                        </div>
                    </div>

                    <div className="bottomLinks clearfix">
                        {requestButton}
                    </div>
                </div>

                <div id="reportArea" className="clearfix">
                    {reportArea}
                </div>
            </div>
        );

    }

}

export default ReportDesignSummary;
